import throttle from 'lodash.throttle';
import { useRef } from 'react';
import { useCreation } from '..';

function useThrottleFn(fn, options) {
  var _a;

  var fnRef = useRef(fn);
  fnRef.current = fn;
  var wait = (_a = options === null || options === void 0 ? void 0 : options.wait) !== null && _a !== void 0 ? _a : 1000;
  var throttled = useCreation(function () {
    return throttle(function () {
      fnRef.current.apply(fnRef, arguments);
    }, wait, options);
  }, []);
  return {
    run: throttled,
    cancel: throttled.cancel
  };
}

export default useThrottleFn;